// In-memory store to pass a fresh analysis between Home -> Scorecard.
// History detail is fetched from the API by id.
let state = {
  result: null,
  personAName: "Person A",
  personBName: "Person B",
  sourceMode: "text",
  sourceTextPreview: null,
  savedId: null,
};

export const analysisStore = {
  set(partial) {
    state = { ...state, ...partial };
  },
  get() {
    return state;
  },
  clear() {
    state = { ...state, result: null, savedId: null };
  },
};

export function scoreColor(score) {
  if (score >= 66) return "#dc2626";
  if (score >= 33) return "#f59e0b";
  return "#22c55e";
}

export function scoreLabel(score) {
  if (score >= 80) return "Severe";
  if (score >= 66) return "High";
  if (score >= 45) return "Elevated";
  if (score >= 25) return "Moderate";
  return "Low";
}
